// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_q1SqA {
  padding: 0px 10px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  border-radius: 20px 0 0 0px;
   background-color: var(--white-background);
}

.clientsHeader_YtBbm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 10px;
  padding: 10px 10px 0px;
  width: 95%;
  .searchContainer_v_47t {
    display: flex;
    align-items: center;
    gap: 20px;
  }
}

.inputWrapper_b7Bbs {
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  border-radius: 0 10px 10px 0;
  .searchInput_MSZSq {
    padding: 10px 10px 10px 35px;
    border: 1px solid var(--ccc-border);
    border-radius: 10px;
    font-size: 16px;
    outline: none;
    width: 250px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    &::placeholder {
      color: var(--aaa-color);
    }
  }
}



.infoBtn_nMEhF {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: var(--_233f39-background);
  color: var(--white-color);
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 15px;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  -ms-border-radius: 15px;
  -o-border-radius: 15px;
  img {
    width: 15px;
    height: 15px;
  }
}
.moreBtn_pyspA {
  width: 40px;
}

.addButton_hCLO0 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 40px;
  width: 40px;
  background-color: var(--_10a37f-background);
  color: var(--white-color);
  border: none;
  cursor: pointer;
  font-size: 16px;
  border-radius: 7px;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  -ms-border-radius: 7px;
  -o-border-radius: 7px;
  img {
    width: 15px;
    height: 15px;
  }
  &:hover {
    background-color: var(--_122521-background);
  }
}

.addIconOutside_Wbqk9 {
  font-size: 18px; 
}

.clientsTable_kOMgO {
  width: 83vw;
  overflow-x: auto;
  box-sizing: border-box;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  border: 1px solid var(--eaecf0-border);
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.name_Pro8i {
  color: var(--_3-color);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  img {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    -ms-border-radius: 100%;
    -o-border-radius: 100%;
  }
}
.titleInfoTd_hMv9f {
  font-weight: 600;
  color: var(--_09090b-color);
}
.table_IdXvr {
  text-align: start;
  border-collapse: collapse; 
  width: 100%;
  thead {
    background-color: var(--f5-background);
  }
}

.table_IdXvr {
  tbody {
    p {
      margin: 0;
    }
    tr {
      border-top: 1px solid var(--eaecf0-border);
      border-bottom: 1px solid var(--eaecf0-border);
      height: 20px;
    }
  }
  th {
    text-align: start;
    padding: 10px; 
    color: var(--_3-color); 
    font-weight: 500; 
    width: 150px; 
    color: var(--_6-color);
  }

  td {
    padding: 10px; 
    color: var(--_6-color);
    font-size: 13px;
    height: 20px;
    p {
      margin: 0;
    }
  }

  thead th {
    min-width: 120px; 
  }

  .small_cWN5I {
    min-width: 140px;
    width: 40px;
  }
  td p:first-of-type {
    margin-bottom: 0;
    display: flex;
    align-items: center;
    gap: 5px;
  }
}
.actions_PV6PZ {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  img {
    cursor: pointer;
  }
}

.transacciones_FT5M6 {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100px;
  a {
    font-weight: bold;
  }
  a,
  span {
    color: var(--_073f31-color);
  }
}

input[type="checkbox"] {
  width: 15px;
  height: 15px;
}

.bg_D79d4 {
  background-color: var(--_FFFFFF80-background) ;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
}

.newClientContainer_i3SSy {
  position: fixed;
  background-color: var(--white-background);
  padding-bottom: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 80vh;
  width: 80%;
  overflow-y: scroll;
  border-radius: 10px;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;

  &::-webkit-scrollbar {
    display: none;
  }

  .newClientForm_XXi60 {
    width: 90%;
    margin: 0 auto;
  }

  .containerHeader_ix3lj {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 30px;
    border-bottom: 1px solid var(--eb-border);
    h3 {
      color: var(--_2-color);
    }
    span {
      background-color: var(--ed-background);
      width: 25px;
      height: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      -ms-border-radius: 5px;
      -o-border-radius: 5px;
      cursor: pointer;
    }
  }

  .phoneInputs_kY2TA {
    width: 100%;
    display: flex;
    input {
      flex: 1 1;
    }
  }

  .row_xgHIt {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  p {
    color: var(--black-color);
    font-weight: 500;
    margin: 0;
  }
  .plan_TQTYK {
    padding-right: 30px;
    span {
      color: var(--black-color);
    }
  }

  .inputContainer_niEko {
    position: relative;
    display: flex;
    align-items: center;
  }
  .input_OLitg {
    width: 100%;
    padding-right: 40px; 
    box-sizing: border-box; 
  }

  .icon_NSdGW {
    position: absolute;
    right: 10px; 
    top: 50%;
    transform: translateY(-50%);
    width: 30px; 
    height: 20px;
    pointer-events: none; 
  }
  label {
    display: flex;
    flex-direction: column;
    color: var(--_71-color);
    gap: 8px;
    margin-bottom: 30px;
    padding: 10px 0;
    border-bottom: 1px solid var(--eb-border);
    input,
    select,
    option {
      padding: 10px;
      border: none;
      outline: none;
      background-color: var(--f5-background);
      border-radius: 4px;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      -ms-border-radius: 4px;
      -o-border-radius: 4px;
    }

    select,
    option {
      color: var(--_75-color);
    }
  }

  .details_lZRbY {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .btnOptionsContainer_UVqsh {
    display: flex;
    width: 100%;
    justify-content: end;
    align-items: center;
    gap: 10px;
    button {
      padding: 10px 20px;
      border-radius: 8px;
      text-decoration: none;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      -ms-border-radius: 8px;
      -o-border-radius: 8px;
    }
    .new_qvw17 {
      background-color: var(--_233f39-background);
      color: var(--white-color);
    }
  }

  button {
    background-color: transparent;
    border: none;
    outline: none;
    text-decoration: underline;
    color: var(--black-color);
    font-weight: 600;
    cursor: pointer;
  }
}

.headerStack_Lj9W7 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.subHeader_hDwfp {
  color: var(--_71717a-color);
  font-size: 12px;
  font-weight: normal;
}

.table_IdXvr th {
  padding: 16px 8px;
  vertical-align: middle;
  color: var(--_48-color);

}

.edit_EWkj6 {
  position: relative;
  display: flex;
  gap: 10px;
  align-items: end;
  opacity: 0;
  padding: 0;
  a {
    color: var(--_073f31-color);
  }
  .dotsOptions_OuHPo {
    cursor: pointer;
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    img {
      width: 18px;
      height: 18px;
    }
  }
}

.allProductC_nUWe6 {
  background-color: var(--white-background);
  padding-bottom: 20px;
  height: 80vh;
  width: 80%;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  animation: scaleUp_eOFmn_iYmHC 300ms ease-out forwards;
  -webkit-animation: scaleUp_eOFmn_iYmHC 300ms ease-out forwards;
}

.formAllProduct_rRrRt::-webkit-scrollbar {
  display: none;
}

.formAllProduct_rRrRt {
  width: 90%;
  margin: 0 auto;
  height: 100%;
  overflow: scroll;
  padding-bottom: 100px;
  box-sizing: border-box;
}

.typeClient_zK__d {
  display: flex;
  background-color: var(--f3-background);
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  padding: 6px;
  gap: 10px;
  width: 300px;
  button {
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    flex: 1 1;
    background-color: transparent;
  }
}
.impuestos_qsoWL,
.sku_uoJHG {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  input {
    border: none;
    outline: none;
    background-color: var(--f4-background);
    padding: 12px;
    box-sizing: border-box;
    resize: none;
    width: 100%;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
  }

  button {
    width: 100%;
    border: 1px solid var(--ced4da-border);
    background-color: var(--fa-background);
    padding: 8px;
    display: flex;
    justify-content: start;
    align-items: center;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    cursor: pointer;
  }

  .percent_wVGpQ,
  .autogenerated_uDsoX {
    display: flex;
    gap: 10px;
    span {
      color: var(--_71717a-color);
    }
    div {
      color: var(--black-color);
      text-decoration: underline;
      font-weight: 600;
      cursor: pointer;
    }
  }
}

.content_menu_actions_LhBOj {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  align-items: center;
  border-radius: 12px;
  background-color: var(--_073f31-background);
  position: absolute;
  padding: 15px;
  bottom: 20px;
  right: 0;

  .item_menu_actions_cgpg3 {
    list-style-type: none;
    color: var(--white-color);
    cursor: pointer;
  }
}
.searchIconsWrappers_rM5d9 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}
.typeClientActivate_ysdY2 {
  button {
    background-color: transparent;
    cursor: pointer;
    color: var(--_9-color);
  }
  .selected_tHXut {
    background-color: var(--white-background);
    box-shadow: 0px 3px 8px var(--ac-shadow);
    color: var(--black-color);
  }
}

.typeClientDisabled_cNM4S {
  background-color: transparent;
}

button[disabled],
input[disabled],
select[disabled],
option[disabled],
textarea[disabled] {
  background-color: transparent;
}
.optionsPopupContainer_UJP2V {
  position: absolute;
  z-index: 9999;
  bottom: -106px;
  left: 41px;
}

.inputWrapperHover_lZIvc {
  position: relative;
  height: 28px;
  min-width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inputWrapperHover_lZIvc:hover{
  .inputContainer_niEko {
    opacity: 1;
  }
}

.inputContainer_niEko {
  background-color: var(--_52525261-background);
  transition: all 300ms;
  width:25px;
  border-radius: 999px;
  height:25px;

  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
}
.optionsTd_N3xRy{
  display: flex;
  flex-direction: row-reverse;
}

.optionsTr_Gl539{
  transition: all 300ms;
}

.optionsTr_Gl539:hover {
  zoom: 1.05;
  box-shadow:
    inset 0 6px 12px -8px color-mix(in srgb, var(--_10a37f-background) 20%, transparent),
    inset 0 -6px 12px -8px color-mix(in srgb, var(--_10a37f-background) 20%, transparent);
}
.optionsTr_Gl539:hover{
  .optionsTd_N3xRy{
    .edit_EWkj6{
      opacity: 1;
    }
  }
}
.mainContainer_cgS2S{
  display: grid;
  grid-template-columns: 3fr 0px;
  transition: grid-template-columns 1.9s ease;
  width: 100%;
  height: 100%;
}

.sectionTableMore_MC_Xb {
grid-template-columns: 3fr 300px;
}

.popupContainer_BnL0y{
  overflow: hidden;
  transform: translateX(100%);
  opacity: 0;
  transition: transform 1.9s ease, opacity 1.9s ease;
}

.popupContainerVisible_usH19  {
  transform: translateX(0);
  opacity: 1;
}

`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/Assets/Assets.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;GAC1B,yCAAyC;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,UAAU;EACV;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B;IACE,4BAA4B;IAC5B,mCAAmC;IACnC,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB;MACE,uBAAuB;IACzB;EACF;AACF;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2CAA2C;EAC3C,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,2CAA2C;EAC3C,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,sCAAsC;EACtC,wBAAwB;EACxB,qBAAqB;EACrB;IACE,aAAa;EACf;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;AACF;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE;MACE,SAAS;IACX;IACA;MACE,0CAA0C;MAC1C,6CAA6C;MAC7C,YAAY;IACd;EACF;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ;MACE,SAAS;IACX;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ;IACE,iBAAiB;EACnB;EACA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;;EAEtB;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,yCAAyC;IACzC;MACE,sBAAsB;IACxB;IACA;MACE,sCAAsC;MACtC,WAAW;MACX,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,eAAe;IACjB;EACF;;EAEA;IACE,WAAW;IACX,aAAa;IACb;MACE,SAAO;IACT;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,mBAAmB;IACnB;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,yCAAyC;IACzC;;;MAGE,aAAa;MACb,YAAY;MACZ,aAAa;MACb,sCAAsC;MACtC,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;IACvB;;IAEA;;MAEE,uBAAuB;IACzB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT;MACE,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB;MACrB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;IACvB;IACA;MACE,2CAA2C;MAC3C,yBAAyB;IAC3B;EACF;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;;AAEzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;;AAEA;EACE,yCAAyC;EACzC,oBAAoB;EACpB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,sDAAgD;EAChD,8DAAwD;AAC1D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,SAAO;IACP,6BAA6B;EAC/B;AACF;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;;EAEX;IACE,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,sCAAsC;IACtC,sCAAsC;IACtC,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,SAAS;IACT;MACE,2BAA2B;IAC7B;IACA;MACE,yBAAyB;MACzB,0BAA0B;MAC1B,gBAAgB;MAChB,eAAe;IACjB;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,QAAQ;;EAER;IACE,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,yCAAyC;IACzC,wCAAwC;IACxC,yBAAyB;EAC3B;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,UAAU;EACV,oBAAoB;EACpB,WAAW;;EAEX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV;;yFAEuF;AACzF;AACA;EACE;IACE;MACE,UAAU;IACZ;EACF;AACF;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,2CAA2C;EAC3C,WAAW;EACX,YAAY;AACd;;AAEA;AACA,gCAAgC;AAChC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ","sourcesContent":[".container {\n  padding: 0px 10px;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-sizing: border-box;\n  border-radius: 20px 0 0 0px;\n   background-color: var(--white-background);\n}\n\n.clientsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 10px;\n  padding: 10px 10px 0px;\n  width: 95%;\n  .searchContainer {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n  }\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  border-radius: 0 10px 10px 0;\n  .searchInput {\n    padding: 10px 10px 10px 35px;\n    border: 1px solid var(--ccc-border);\n    border-radius: 10px;\n    font-size: 16px;\n    outline: none;\n    width: 250px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n    &::placeholder {\n      color: var(--aaa-color);\n    }\n  }\n}\n\n\n\n.infoBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  background-color: var(--_233f39-background);\n  color: var(--white-color);\n  border: none;\n  padding: 10px;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 15px;\n  -webkit-border-radius: 15px;\n  -moz-border-radius: 15px;\n  -ms-border-radius: 15px;\n  -o-border-radius: 15px;\n  img {\n    width: 15px;\n    height: 15px;\n  }\n}\n.moreBtn {\n  width: 40px;\n}\n\n.addButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  height: 40px;\n  width: 40px;\n  background-color: var(--_10a37f-background);\n  color: var(--white-color);\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 7px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  -ms-border-radius: 7px;\n  -o-border-radius: 7px;\n  img {\n    width: 15px;\n    height: 15px;\n  }\n  &:hover {\n    background-color: var(--_122521-background);\n  }\n}\n\n.addIconOutside {\n  font-size: 18px; \n}\n\n.clientsTable {\n  width: 83vw;\n  overflow-x: auto;\n  box-sizing: border-box;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  border: 1px solid var(--eaecf0-border);\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.name {\n  color: var(--_3-color);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  img {\n    width: 30px;\n    height: 30px;\n    border-radius: 100%;\n    -webkit-border-radius: 100%;\n    -moz-border-radius: 100%;\n    -ms-border-radius: 100%;\n    -o-border-radius: 100%;\n  }\n}\n.titleInfoTd {\n  font-weight: 600;\n  color: var(--_09090b-color);\n}\n.table {\n  text-align: start;\n  border-collapse: collapse; \n  width: 100%;\n  thead {\n    background-color: var(--f5-background);\n  }\n}\n\n.table {\n  tbody {\n    p {\n      margin: 0;\n    }\n    tr {\n      border-top: 1px solid var(--eaecf0-border);\n      border-bottom: 1px solid var(--eaecf0-border);\n      height: 20px;\n    }\n  }\n  th {\n    text-align: start;\n    padding: 10px; \n    color: var(--_3-color); \n    font-weight: 500; \n    width: 150px; \n    color: var(--_6-color);\n  }\n\n  td {\n    padding: 10px; \n    color: var(--_6-color);\n    font-size: 13px;\n    height: 20px;\n    p {\n      margin: 0;\n    }\n  }\n\n  thead th {\n    min-width: 120px; \n  }\n\n  .small {\n    min-width: 140px;\n    width: 40px;\n  }\n  td p:first-of-type {\n    margin-bottom: 0;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n}\n.actions {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  img {\n    cursor: pointer;\n  }\n}\n\n.transacciones {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  width: 100px;\n  a {\n    font-weight: bold;\n  }\n  a,\n  span {\n    color: var(--_073f31-color);\n  }\n}\n\ninput[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n}\n\n.bg {\n  background-color: var(--_FFFFFF80-background) ;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n}\n\n.newClientContainer {\n  position: fixed;\n  background-color: var(--white-background);\n  padding-bottom: 20px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  height: 80vh;\n  width: 80%;\n  overflow-y: scroll;\n  border-radius: 10px;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  .newClientForm {\n    width: 90%;\n    margin: 0 auto;\n  }\n\n  .containerHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 30px;\n    border-bottom: 1px solid var(--eb-border);\n    h3 {\n      color: var(--_2-color);\n    }\n    span {\n      background-color: var(--ed-background);\n      width: 25px;\n      height: 25px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 5px;\n      -webkit-border-radius: 5px;\n      -moz-border-radius: 5px;\n      -ms-border-radius: 5px;\n      -o-border-radius: 5px;\n      cursor: pointer;\n    }\n  }\n\n  .phoneInputs {\n    width: 100%;\n    display: flex;\n    input {\n      flex: 1;\n    }\n  }\n\n  .row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  p {\n    color: var(--black-color);\n    font-weight: 500;\n    margin: 0;\n  }\n  .plan {\n    padding-right: 30px;\n    span {\n      color: var(--black-color);\n    }\n  }\n\n  .inputContainer {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n  .input {\n    width: 100%;\n    padding-right: 40px; \n    box-sizing: border-box; \n  }\n\n  .icon {\n    position: absolute;\n    right: 10px; \n    top: 50%;\n    transform: translateY(-50%);\n    width: 30px; \n    height: 20px;\n    pointer-events: none; \n  }\n  label {\n    display: flex;\n    flex-direction: column;\n    color: var(--_71-color);\n    gap: 8px;\n    margin-bottom: 30px;\n    padding: 10px 0;\n    border-bottom: 1px solid var(--eb-border);\n    input,\n    select,\n    option {\n      padding: 10px;\n      border: none;\n      outline: none;\n      background-color: var(--f5-background);\n      border-radius: 4px;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      -ms-border-radius: 4px;\n      -o-border-radius: 4px;\n    }\n\n    select,\n    option {\n      color: var(--_75-color);\n    }\n  }\n\n  .details {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .btnOptionsContainer {\n    display: flex;\n    width: 100%;\n    justify-content: end;\n    align-items: center;\n    gap: 10px;\n    button {\n      padding: 10px 20px;\n      border-radius: 8px;\n      text-decoration: none;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n    }\n    .new {\n      background-color: var(--_233f39-background);\n      color: var(--white-color);\n    }\n  }\n\n  button {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    text-decoration: underline;\n    color: var(--black-color);\n    font-weight: 600;\n    cursor: pointer;\n  }\n}\n\n.headerStack {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.subHeader {\n  color: var(--_71717a-color);\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.table th {\n  padding: 16px 8px;\n  vertical-align: middle;\n  color: var(--_48-color);\n\n}\n\n.edit {\n  position: relative;\n  display: flex;\n  gap: 10px;\n  align-items: end;\n  opacity: 0;\n  padding: 0;\n  a {\n    color: var(--_073f31-color);\n  }\n  .dotsOptions {\n    cursor: pointer;\n    transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n    img {\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n.allProductC {\n  background-color: var(--white-background);\n  padding-bottom: 20px;\n  height: 80vh;\n  width: 80%;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  animation: scaleUp_eOFmn 300ms ease-out forwards;\n  -webkit-animation: scaleUp_eOFmn 300ms ease-out forwards;\n}\n\n.formAllProduct::-webkit-scrollbar {\n  display: none;\n}\n\n.formAllProduct {\n  width: 90%;\n  margin: 0 auto;\n  height: 100%;\n  overflow: scroll;\n  padding-bottom: 100px;\n  box-sizing: border-box;\n}\n\n.typeClient {\n  display: flex;\n  background-color: var(--f3-background);\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  padding: 6px;\n  gap: 10px;\n  width: 300px;\n  button {\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    flex: 1;\n    background-color: transparent;\n  }\n}\n.impuestos,\n.sku {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n\n  input {\n    border: none;\n    outline: none;\n    background-color: var(--f4-background);\n    padding: 12px;\n    box-sizing: border-box;\n    resize: none;\n    width: 100%;\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n  }\n\n  button {\n    width: 100%;\n    border: 1px solid var(--ced4da-border);\n    background-color: var(--fa-background);\n    padding: 8px;\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    cursor: pointer;\n  }\n\n  .percent,\n  .autogenerated {\n    display: flex;\n    gap: 10px;\n    span {\n      color: var(--_71717a-color);\n    }\n    div {\n      color: var(--black-color);\n      text-decoration: underline;\n      font-weight: 600;\n      cursor: pointer;\n    }\n  }\n}\n\n.content_menu_actions {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n  align-items: center;\n  border-radius: 12px;\n  background-color: var(--_073f31-background);\n  position: absolute;\n  padding: 15px;\n  bottom: 20px;\n  right: 0;\n\n  .item_menu_actions {\n    list-style-type: none;\n    color: var(--white-color);\n    cursor: pointer;\n  }\n}\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n.typeClientActivate {\n  button {\n    background-color: transparent;\n    cursor: pointer;\n    color: var(--_9-color);\n  }\n  .selected {\n    background-color: var(--white-background);\n    box-shadow: 0px 3px 8px var(--ac-shadow);\n    color: var(--black-color);\n  }\n}\n\n.typeClientDisabled {\n  background-color: transparent;\n}\n\nbutton[disabled],\ninput[disabled],\nselect[disabled],\noption[disabled],\ntextarea[disabled] {\n  background-color: transparent;\n}\n.optionsPopupContainer {\n  position: absolute;\n  z-index: 9999;\n  bottom: -106px;\n  left: 41px;\n}\n\n.inputWrapperHover {\n  position: relative;\n  height: 28px;\n  min-width: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.inputWrapperHover:hover{\n  .inputContainer {\n    opacity: 1;\n  }\n}\n\n.inputContainer {\n  background-color: var(--_52525261-background);\n  transition: all 300ms;\n  width:25px;\n  border-radius: 999px;\n  height:25px;\n\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 300ms;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n}\n.optionsTd{\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.optionsTr{\n  transition: all 300ms;\n}\n\n.optionsTr:hover {\n  zoom: 1.05;\n  box-shadow:\n    inset 0 6px 12px -8px color-mix(in srgb, var(--_10a37f-background) 20%, transparent),\n    inset 0 -6px 12px -8px color-mix(in srgb, var(--_10a37f-background) 20%, transparent);\n}\n.optionsTr:hover{\n  .optionsTd{\n    .edit{\n      opacity: 1;\n    }\n  }\n}\n.mainContainer{\n  display: grid;\n  grid-template-columns: 3fr 0px;\n  transition: grid-template-columns 1.9s ease;\n  width: 100%;\n  height: 100%;\n}\n\n.sectionTableMore {\ngrid-template-columns: 3fr 300px;\n}\n\n.popupContainer{\n  overflow: hidden;\n  transform: translateX(100%);\n  opacity: 0;\n  transition: transform 1.9s ease, opacity 1.9s ease;\n}\n\n.popupContainerVisible  {\n  transform: translateX(0);\n  opacity: 1;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_q1SqA`,
	"clientsHeader": `clientsHeader_YtBbm`,
	"searchContainer": `searchContainer_v_47t`,
	"inputWrapper": `inputWrapper_b7Bbs`,
	"searchInput": `searchInput_MSZSq`,
	"infoBtn": `infoBtn_nMEhF`,
	"moreBtn": `moreBtn_pyspA`,
	"addButton": `addButton_hCLO0`,
	"addIconOutside": `addIconOutside_Wbqk9`,
	"clientsTable": `clientsTable_kOMgO`,
	"name": `name_Pro8i`,
	"titleInfoTd": `titleInfoTd_hMv9f`,
	"table": `table_IdXvr`,
	"small": `small_cWN5I`,
	"actions": `actions_PV6PZ`,
	"transacciones": `transacciones_FT5M6`,
	"bg": `bg_D79d4`,
	"newClientContainer": `newClientContainer_i3SSy`,
	"newClientForm": `newClientForm_XXi60`,
	"containerHeader": `containerHeader_ix3lj`,
	"phoneInputs": `phoneInputs_kY2TA`,
	"row": `row_xgHIt`,
	"plan": `plan_TQTYK`,
	"inputContainer": `inputContainer_niEko`,
	"input": `input_OLitg`,
	"icon": `icon_NSdGW`,
	"details": `details_lZRbY`,
	"btnOptionsContainer": `btnOptionsContainer_UVqsh`,
	"new": `new_qvw17`,
	"headerStack": `headerStack_Lj9W7`,
	"subHeader": `subHeader_hDwfp`,
	"edit": `edit_EWkj6`,
	"dotsOptions": `dotsOptions_OuHPo`,
	"allProductC": `allProductC_nUWe6`,
	"scaleUp_eOFmn": `scaleUp_eOFmn_iYmHC`,
	"formAllProduct": `formAllProduct_rRrRt`,
	"typeClient": `typeClient_zK__d`,
	"impuestos": `impuestos_qsoWL`,
	"sku": `sku_uoJHG`,
	"percent": `percent_wVGpQ`,
	"autogenerated": `autogenerated_uDsoX`,
	"content_menu_actions": `content_menu_actions_LhBOj`,
	"item_menu_actions": `item_menu_actions_cgpg3`,
	"searchIconsWrappers": `searchIconsWrappers_rM5d9`,
	"typeClientActivate": `typeClientActivate_ysdY2`,
	"selected": `selected_tHXut`,
	"typeClientDisabled": `typeClientDisabled_cNM4S`,
	"optionsPopupContainer": `optionsPopupContainer_UJP2V`,
	"inputWrapperHover": `inputWrapperHover_lZIvc`,
	"optionsTd": `optionsTd_N3xRy`,
	"optionsTr": `optionsTr_Gl539`,
	"mainContainer": `mainContainer_cgS2S`,
	"sectionTableMore": `sectionTableMore_MC_Xb`,
	"popupContainer": `popupContainer_BnL0y`,
	"popupContainerVisible": `popupContainerVisible_usH19`
};
export default ___CSS_LOADER_EXPORT___;
